import {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


UploaderDropZone.propTypes = {
    disabled: PropTypes.bool,
    onDrop: PropTypes.func,
};

UploaderDropZone.defaultProps = {
    onDrop: () => {}
};

export default function UploaderDropZone(props) {
    const dragDepth = useRef(0);
    const [draggingFiles, setDraggingFiles] = useState(false);
    
    // This counter is used to determine how many containers the drag event as entered
    // Due to the nature of drag and drop in elements children in the container can cause the drag leave event to occur.
    // Using a count, when it reaches 0 indicating that we have left the drop container the drop effect classes will be 
    // removed.
    /**
     * Fired on onDragEnter, onDragLeave, onDragOver, onDrop. See JXS below
     * 
     * @param e The {@link DragEvent}
     */
    const onDragEvent = (e) => {
        if (props.disabled) return;
        // Reordering items and dragging text must not activate the file drop target.
        if (!Array.from(e.dataTransfer?.types || []).includes('Files')) return;
        e.preventDefault();
        e.stopPropagation();
        
        switch (e.type) {
            case 'dragenter':
                dragDepth.current++;
                setDraggingFiles(true);
                return;
            case 'dragleave':
                dragDepth.current = Math.max(0, dragDepth.current - 1);
                if (!dragDepth.current) setDraggingFiles(false);
                return;
            case 'drop':
                dragDepth.current = 0;
                setDraggingFiles(false);
                props.onDrop(e);
                return;
        }
    }
    
    return (
        <div
            className={classNames(
                "relative flex flex-col text-sm focus:ring-primary-500 focus:border-primary-500 rounded",
                props.disabled ? "pointer-events-none" : null,
                props.error && !props.disabled ? 'border-error-300' : null,
                !props.error && !props.disabled ? 'border-gray-300' : null,
                props.modified ? 'focus:outline-2 focus:outline-dashed focus:outline-offset-2 focus:outline-fuchsia-400 outline-2 outline-dashed outline-offset-2 outline-fuchsia-400' : null,
                draggingFiles && !props.disabled ? 'ring-2 ring-primary-500 ring-offset-4' : null,
            )}
            onDragEnter={onDragEvent}
            onDragLeave={onDragEvent}
            onDragOver={onDragEvent}
            onDrop={onDragEvent}
            onDragEnd={() => {dragDepth.current = 0; setDraggingFiles(false);}}
        >
            {props.children}
        </div>
    );
};
